import {
  AssessmentState,
  AssessmentActionTypes,
  SET_ASSESSMENT_ID,
  SET_RESPONSE,
  SET_RESPONSES,
  UPDATE_MINUTES_LEFT,
  SET_STATUS,
  CLEAR_RESPONSES,
} from '../types/assessment';

// Load initial state from localStorage
const loadStateFromLocalStorage = (): AssessmentState => {
  try {
    const serializedState = localStorage.getItem('assessment-storage');
    if (serializedState) {
      return JSON.parse(serializedState);
    }
  } catch (err) {
    console.error('Failed to load assessment state from localStorage:', err);
  }
  return {
    assessmentId: null,
    responses: {},
    minutesLeft: 60,
    status: null,
  };
};

const initialState: AssessmentState = loadStateFromLocalStorage();

const assessmentReducer = (
  state = initialState,
  action: AssessmentActionTypes
): AssessmentState => {
  switch (action.type) {
    case SET_ASSESSMENT_ID:
      return {
        ...state,
        assessmentId: action.payload,
      };

    case SET_RESPONSE:
      return {
        ...state,
        responses: {
          ...state.responses,
          [action.payload.key]: action.payload.value,
        },
      };

    case SET_RESPONSES:
      return {
        ...state,
        responses: {
          ...state.responses,
          ...action.payload,
        },
      };

    case UPDATE_MINUTES_LEFT:
      return {
        ...state,
        minutesLeft: action.payload,
      };

    case SET_STATUS:
      return {
        ...state,
        status: action.payload,
      };

    case CLEAR_RESPONSES:
      localStorage.removeItem('assessment-storage');
      return {
        assessmentId: null,
        responses: {},
        minutesLeft: 60,
        status: null,
      };

    default:
      return state;
  }
};

export default assessmentReducer;
